import { Injectable } from '@angular/core';
import { convertDesignIdToCommunicationId } from 'src/app/lego-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ToySafetyReport } from 'src/app/models/domain';
import { TestReportsService } from 'src/generated-clients/toy-safety-reports';

function appendDesignIdToMigratedReportUrl(webUrl: string, communicationId: string): URL {
  const url = new URL(webUrl);

  if (url.search !== '') {
    url.searchParams.append('DesignId', communicationId);
  }

  return url;
}

@Injectable({ providedIn: 'root' })
export class ToySafetyReportService {
  public constructor(private readonly testReportsService: TestReportsService) {}

  public loadByDesignId(designId: string): Observable<ToySafetyReport[]> {
    const communicationId = convertDesignIdToCommunicationId(designId);

    return this.testReportsService
      .getTestReportsByDesignId(communicationId)
      .pipe(
        map((response) =>
          response.testReports.map(
            (r) =>
              new ToySafetyReport(
                r.name,
                r.versionNumber,
                r.isApproved,
                r.status,
                r.material,
                appendDesignIdToMigratedReportUrl(r.webUrl, communicationId),
                r.mouldNumber ?? undefined
              )
          )
        )
      );
  }
}
